var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ProductLinkComponent.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-5023e6ea!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ProductLinkComponent.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/grid/ProductLinkComponent.vue
// module id = 128
// module chunks = 2